/* eslint-disable no-unused-vars */
/* eslint-disable */
import { Button, Checkbox, Container, FormControlLabel, Menu, MenuItem, TextField } from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';
import P from 'prop-types';
import { useEffect, useState } from 'react';
import InputMask from 'react-input-mask';
import useSWR from 'swr';
// import { MainContext } from '../../../context/ApiContext';
import { useAuth } from '../../../hooks/useAuth';
import { fetcher } from '../../../service/SWRFetcher';
import { Nav, NavbarForm, Links } from './styles';

const Navbar = ({
  clickFilter,
  clickFilterBtn,
  clearFilter,
  clickSevenDays,
  checkValue,
  scheduler,
  setLockTabs,
  clearSelected,
  clickOnlySchedules,
  checkValueSchedules,
}) => {
  const { user } = useAuth();
  const { data: users, mutate: mutateUsers, isValidating } = useSWR(user.role < 3 ? `/users` : null, fetcher);

  // const { values } = useContext(MainContext);
  // const {
  //   values: { users },
  // } = useContext(MainContext);
  const [brokerId, setBrokerId] = useState();
  const [filters, setFilters] = useState({
    lead_id: '',
    name: '',
    broker: '',
    cpf: '',
    start_date: '',
    end_date: '',
  });

  // const [anchorEl, setAnchorEl] = useState(null);
  // const [selectFilter, setSelectFilter] = useState(null);
  const [filterBtn, setFilterBtn] = useState({
    name: '',
    value: '',
    change: false,
  });

  useEffect(() => {
    // console.log(filterBtn);
    if (filterBtn.change === true) {
      setFilterBtn({ ...filterBtn, change: false });
      if (typeof filterBtn.value !== 'number') setFilterBtn({ name: '', value: '' });
      else clickFilterBtn(filterBtn.name, filterBtn.value);
    }
  }, [filterBtn.change]);

  // useEffect(() => {
  //   console.log(selectFilter);
  // }, [selectFilter])

  // const handleClick = (event) => {
  //   setFilterBtn({ ...filterBtn, name: event.currentTarget.name.toLowerCase().slice(0, -1) });
  //   if (event.currentTarget.name === 'channels') setSelectFilter(values[event.currentTarget.name]);
  //   else setSelectFilter([{ id: 0, name: 'Nenhum' }, ...values[event.currentTarget.name]]);
  //   setAnchorEl(event.currentTarget);
  // };

  // const handleClose = (id) => {
  //   setFilterBtn({ ...filterBtn, value: id, change: true });
  //   setAnchorEl(null);
  // };

  const handleChange = (e) => {
    setFilters({ ...filters, [e.target.name]: e.target.value });
  };

  return (
    <Nav>
      <NavbarForm>
        <div className="filter">Filtros</div>

        <Container className="area-form">
          <div className="name">
            <input
              type="text"
              className="input-form"
              placeholder="Nome"
              name="name"
              value={filters.name}
              onChange={handleChange}
            />
          </div>
          <div className="lead_id">
            <input
              type="text"
              className="input-form"
              placeholder="Núm. do Lead"
              name="lead_id"
              value={filters.lead_id}
              onChange={handleChange}
            />
          </div>
          <div className="cpf">
            <InputMask
              maskChar=""
              mask={filters.cpf.replace(/[^\d]/g, '').length < 12 ? '999.999.999-999' : '99.999.999/9999-99'}
              type="text"
              className="input-form"
              name="cpf"
              placeholder="CPF"
              value={filters.cpf}
              onChange={handleChange}
            />
          </div>
          <div className="broker">
            <input
              list="select"
              name="broker"
              className="select-form"
              placeholder="Corretor"
              value={filters.broker}
              onChange={handleChange}
            />
            <datalist id="select">
              {user.role < 3 ? (
                users?.map((item) => (
                  <option key={item.id} value={item.name}>
                    {' '}
                  </option>
                ))
              ) : (
                <option key={user.id} value={user.name}>
                  {' '}
                </option>
              )}
            </datalist>
          </div>
          <div className="date_ini">
            <input
              type="date"
              name="start_date"
              className="input-form"
              placeholder="Data Inicial"
              value={filters.start_date}
              onChange={handleChange}
            />
          </div>
          <div className="date_end">
            <input
              type="date"
              name="end_date"
              className="input-form"
              placeholder="Data Inicial"
              value={filters.end_date}
              onChange={handleChange}
            />
          </div>
        </Container>

        <Container className="area-btn">
          <Button
            variant="contained"
            onClick={() => {
              setLockTabs(false),
                clearSelected(),
                clickFilter(
                  filters.name,
                  filters.cpf.replace(/[^0-9]/g, ''),
                  filters.broker,
                  filters.start_date,
                  filters.end_date,
                  filters.lead_id
                );
            }}>
            Filtrar
          </Button>
          <Button
            variant="contained"
            onClick={() => {
              clearFilter();
              clearSelected();
              setFilters({
                lead_id: '',
                name: '',
                broker: '',
                cpf: '',
                start_date: '',
                end_date: '',
              });
            }}>
            Limpar Filtros
          </Button>

          {/* {scheduler && (
            <FormControlLabel
              style={{ marginLeft: 10 }}
              control={<Checkbox color="default" onChange={clickSevenDays} checked={checkValue} name="checkedA" />}
              label="Agendados nos próximos 7 dias"
            />
          )} */}
          {/* <FormControlLabel
            // style={{ marginLeft: 10 }}
            className="btn-only-agendaments"
            control={
              <Checkbox color="default" onChange={clickOnlySchedules} checked={checkValueSchedules} name="checkedA" />
            }
            label="Somente Agendamentos"
          /> */}
        </Container>
      </NavbarForm>

      {/* <Links>
        <div className="fields">
          <Button name="channels" onClick={handleClick}>
            Canal
          </Button>
          <Button name="insurances" onClick={handleClick}>
            Tipo de Seguro
          </Button>
          <Button name="partners" onClick={handleClick}>
            Parceiros
          </Button>

          <Menu
            id="simple-menu"
            anchorEl={anchorEl}
            keepMounted
            open={Boolean(anchorEl)}
            onClose={handleClose}
            PaperProps={{
              style: {
                maxHeight: 48 * 4.5,
              },
            }}>
            {selectFilter?.map((f) => (
              <MenuItem key={f.id} onClick={() => handleClose(f.id)}>
                {f.name}
              </MenuItem>
            ))}
          </Menu>
        </div>
      </Links> */}
    </Nav>
  );
};

Navbar.propTypes = {
  clickFilter: P.func,
  clearFilter: P.func,
  clickFilterBtn: P.func,
  clickSevenDays: P.func,
  scheduler: P.bool,
  checkValue: P.bool,
};
Navbar.defaultProps = {
  clickFilter: () => {},
  clickFilterBtn: () => {},
  clearFilter: () => {},
  clickSevenDays: () => {},
  scheduler: false,
  checkValue: true,
};

export default Navbar;
